var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-notification-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "notification-content" },
      _vm._l(_vm.groups, function (group) {
        return _c("BasicActions", {
          key: group.id,
          attrs: {
            settings: _vm.settings,
            title: group.title,
            "allowed-scopes": group.allowedScopes,
          },
          on: { update: _vm.updateScopeNotificationSettings },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notification-header" }, [
      _c("div", { staticClass: "header-icon" }, [
        _c("span", { staticClass: "material-icons" }, [
          _vm._v("notifications"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-content" }, [
        _c("h1", { staticClass: "header-title" }, [
          _vm._v("Task Bildirim Ayarları"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "header-description" }, [
          _vm._v(
            "\n                Görev bildirim ayarlarınızı buradan yönetebilirsiniz.\n            "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }